<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <ContractsSignDocumentsModal
            v-if="contractId"
            ref="ContractsSignDocumentsModal"
            :contractId="contractId"
            :contractHold="contractHold"
            :isNewContract="!!($route.query && $route.query.nieuw === 'true')"
            :showButton="false"
            includedFrom="connect"
        />

        <ConnectionModal
            ref="ConnectionModal"
            :organisationId="record.organisation"
            :record="record"
            :editingDroplet="editingDroplet"
            embedded_from="ConnectRecord"
            @passAccessLevelsAndDepartments="passAccessLevelsAndDepartments"
            @passPaxtonUser="passPaxtonUser"
            @createNewKeyfob="createNewKeyfob"
            @paxtonUserSaved="saveAndQuit"
        />

        <ConnectionEditTag
            ref="ConnectionEditTag"
            :organisationId="record.organisation"
            :editingDroplet="editingDroplet"
            :record="record"
            @updateDroplet="updateDroplet"
            @deleteDroplet="deleteDroplet"
            @setEditingDroplet="setEditingDroplet"
        />

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" to="/panel/connect/" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-9">
                <h1>{{ $route.params.id == 'nieuw' ? 'Toegang aanmaken' : 'Toegang aanpassen' }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="tabIndex">
                        <b-tab-item label="Algemeen">
                            <!-- Contract on hold notification -->
                            <div v-if="contractHold == 1 && $route.query && $route.query.nieuw">
                                <b-notification type="is-warning is-light" role="alert">
                                    <p class="marginbottom0"><strong>Let op:</strong>&nbsp;Het volledige contract wordt verstuurd zodra alle contractdocumenten door de klant zijn ondertekend. De klant heeft een e-mail ontvangen met een link om de documenten digitaal te ondertekenen.</p>
                                </b-notification>
                                <br>
                            </div>

                            <div class="row">
                                <div class="column">
                                    <b-field label="Organisatie (PIT) - Local only"
                                        :message="getError(errors, 'organisation')"
                                        :type="getType(errors, 'organisation', '')"
                                        v-if="user && user.role == 'pit' && $store.state.env === 'local'"
                                    >
                                        <span>
                                            <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                                <option
                                                    v-for="organisation in organisations"
                                                    :value="organisation.id"
                                                    :key="'organisatie_'+organisation.id"
                                                >(ID: {{ organisation.id }}) {{ organisation.name }}</option>
                                            </b-select>
                                        </span>
                                    </b-field>

                                    <b-field label="Klant"
                                        :message="getError(errors, 'customer')"
                                        :type="getType(errors, 'customer', '')"
                                    >
                                        <b-autocomplete
                                            v-model="customerSearch"
                                            placeholder="Zoeken naar klant op voornaam, achternaam, email of plaats"
                                            :open-on-focus="true"
                                            :data="customers"
                                            field="id"
                                            @select="option => (record.customer = option)"
                                            :clearable="true"
                                            :loading="fetchingCustomers"
                                            @typing="fetchCustomersDebounce"
                                            :disabled="!record.organisation"
                                            v-if="_.isNull(record.customer)"
                                        >
                                            <template v-slot="props">
                                                {{ props.option.firstname }}&nbsp;{{ props.option.lastname }}
                                                <span v-if="!_.isNull(props.option.companyname) && (props.option.type == 'business' || props.option.type == 'foundation')">
                                                    <strong>({{ props.option.companyname }})</strong>
                                                </span> - {{ props.option.city }}
                                            </template>
                                        </b-autocomplete>
                                        <div v-else>
                                            {{ record.customer.firstname }}&nbsp;{{ record.customer.lastname }}
                                            <span v-if="!_.isNull(record.customer.companyname) && (record.customer.type == 'business' || record.customer.type == 'foundation')">
                                                <strong>({{ record.customer.companyname }})</strong>
                                            </span> - {{ record.customer.city }}
                                            <b-button type="is-danger" size="is-small" icon-right="times" @click="deselectCustomer" v-if="mode == 'new' || !$route.query.customer"></b-button>
                                        </div>
                                    </b-field>

                                    <b-field label="Afdeling"
                                        :message="getError(errors, 'department')"
                                        :type="getType(errors, 'department', '')"
                                    >
                                        <b-select placeholder="Kies een afdeling" v-model="record.department" v-if="!_.isNull(userDepartments) && userDepartments.length" expanded>
                                            <!-- <option :value="null" :selected="_.isNull(record.contract)">Geen toegang</option> -->
                                            <option
                                                v-for="dep in userDepartments"
                                                :value="dep.id"
                                                :key="'userDepartment_'+dep.id"
                                            >{{ dep.name }}</option>
                                        </b-select>
                                        <p v-else>
                                            Geen afdelingen gevonden.
                                        </p>
                                    </b-field>

                                    <b-field label="Autorisatie toegang"
                                        :message="getError(errors, 'accesslevel')"
                                        :type="getType(errors, 'accesslevel', '')"
                                    >
                                        <b-select placeholder="Kies een autorisatie toegang" v-model="record.accesslevel" v-if="!_.isNull(accessLevels) && accessLevels.length" expanded>
                                            <!-- <option :value="null" :selected="_.isNull(record.contract)">Geen toegang</option> -->
                                            <option
                                                v-for="accessLevel in accessLevels"
                                                :value="accessLevel.id"
                                                :key="'accessLevel_'+accessLevel.id"
                                            >{{ accessLevel.name }}</option>
                                        </b-select>
                                        <p v-else>
                                            Geen autorisaties gevonden.
                                        </p>
                                    </b-field>

                                    <b-field
                                        :message="getError(errors[1], 'contract')"
                                        :type="getType(errors[1], 'contract', '')"
                                        v-if="!$route.query.contract"
                                    >
                                            <template #label>Contract<b-tooltip type="is-dark" label="Door een contract te koppelen kan je ook vanuit het contract de toegang aanpassen of intrekken."><b-icon size="is-small" icon="question-circle"></b-icon></b-tooltip></template>
                                            <b-select placeholder="Kies een contract (optioneel)" v-model="record.contract" :disabled="_.isNull(record.customer) || fetchingContracts" :loading="fetchingContracts" expanded>
                                                <option :value="null" :selected="_.isNull(record.contract)">Zonder contract</option>
                                                <option
                                                    v-for="contract in contracts"
                                                    :value="contract.id"
                                                    :key="'contract_'+contract.id"
                                                >Contract met startdatum {{ moment(contract.start_date).format('DD-MM-YYYY') }}</option>
                                            </b-select>
                                    </b-field>
                                    <!-- Contract supplied by the URL -->
                                    <b-field label="Contract" v-else>
                                        Contract #{{ $route.query.contract }}
                                    </b-field>

                                    <b-field label="Toegang vanaf"
                                        :message="getError(errors[1], 'date_from')"
                                        :type="getType(errors[1], 'date_from', '')"
                                    >
                                        <b-datepicker
                                            placeholder="Klik om te selecteren"
                                            :nearby-selectable-month-days="true"
                                            icon="calendar-alt"
                                            icon-pack="fas"
                                            :min-date="moment(new Date()).startOf('day').toDate()"
                                            v-model="record.date_from"
                                            v-if="mode == 'new'"
                                        />
                                        <div v-else>{{ moment(record.date_from).format('DD-MM-YYYY') }}</div>
                                    </b-field>

                                    <b-checkbox v-model="record.undetermined">
                                        Toegang voor onbepaalde tijd
                                    </b-checkbox>

                                    <slide-up-down :active="!record.undetermined" :duration="500">
                                        <div v-if="!record.undetermined">
                                            <br>
                                            <b-field label="Einddatum toegang"
                                                :message="getError(errors, 'date_to')"
                                                :type="getType(errors, 'date_to', '')"
                                            >
                                                <b-datepicker
                                                    placeholder="Klik om te selecteren"
                                                    :nearby-selectable-month-days="true"
                                                    icon="calendar-alt"
                                                    icon-pack="fas"
                                                    :min-date="moment(new Date(record.date_from)).startOf('day').toDate()"
                                                    v-model="record.date_to"
                                                />
                                                <!-- <div>{{ moment(record.date_to).format('DD-MM-YYYY') }}</div> -->
                                            </b-field>
                                        </div>
                                    </slide-up-down>
                                </div>
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Tags" v-if="mode == 'edit'">
                            <div class="row">
                                <div class="column small-9">
                                    <h3>Tags</h3>
                                </div>
                                <div class="column small-3 text-right">
                                    <b-button type="is-success" @click="addKeyfob">Tag toevoegen</b-button>
                                </div>
                            </div>

                            <b-table
                                :data="_.isNull(record.keyfob) ? [] : record.keyfob"
                                :striped="true"
                                :loading="loading"
                                :mobile-cards="true"

                                :total="1000"
                                :per-page="1000"
                            >
                                <template>
                                    <b-table-column v-slot="props" field="tokenType" label="Type" width="150">
                                        {{ props.row.tokenType == 'Keyfob' ? 'Tag' : 'Onbekend' }}
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="tokenValue" label="Nummer">
                                        {{ props.row.tokenValue }}
                                    </b-table-column>

                                    <b-table-column v-slot="props" field="isLost" label="Verloren" width="200">
                                        <b-tooltip :label="props.row.isLost ? 'Kaart als gevonden registreren' : 'Kaart als verloren registreren'" position="is-top">
                                            <b-button :type="props.row.isLost ? 'is-success' : 'is-primary'" icon-left="trash-alt" size="is-small"  @click="$refs['ConnectionEditTag'].openModal(props.row.isLost ? 'found' : 'lost', props.row.id)" />
                                        </b-tooltip>
                                    </b-table-column>

                                    <b-table-column v-slot="props" label="Verwijderen" width="200" numeric>
                                        <b-button type="is-danger" icon-left="trash-alt" size="is-small" @click="$refs['ConnectionEditTag'].openModal('remove', props.row.id)" />
                                    </b-table-column>
                                </template>

                                <template #empty>
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p class="margin0" v-if="loading === false">Geen tags gevonden.</p>
                                            <p class="margin0" v-else>Laden...</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>

                            <!-- - Tag als verloren opgeven
                            - Tag verwijderen
                            - Tag toevoegen aan (paxton) gebruiker -->

                        </b-tab-item>

                        <!-- TODO: Add logs -->
                        <!-- <b-tab-item label="Logs" v-if="this.type == 'edit' && user && user.role == 'pit'">
                            <h3>Logs</h3>

                            <LogsRecord
                                ref="LogsRecord"
                                :getFilters="{0: {name: record.number, query: { subject_type: 'App\\Product', subject_id: record.id }}}"
                            />
                        </b-tab-item> -->
                    </b-tabs>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="column text-right">
                <div class="formfooter">
                    <b-button type="is-danger" :loading="loading" v-if="mode == 'edit' && revokable" @click="revokeAccess">Toegang intrekken</b-button>
                    <b-button type="is-success" :loading="loading" @click="createOrEditRecord" v-if="mode == 'new'">Toegang aanmaken</b-button>
                    <b-button type="is-success" :loading="loading" @click="createOrEditRecord" v-else>Aanpassen</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LogsRecord from '../logs/LogsRecord'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixins from '@/mixins/toastMixins.js'
import ConnectionModal from './ConnectionModal'
import ConnectionEditTag from './ConnectionEditTag'
import ContractsSignDocumentsModal from '../contracts/ContractsSignDocumentsModal'

export default {
    name: 'ConnectRecord',

    components: {
        LogsRecord,
        ConnectionModal,
        ConnectionEditTag,
        ContractsSignDocumentsModal
    },

    mixins: [formvalidationMixin, toastMixins],

    data () {
        return {
            mode: 'new',
            isSaving: false,
            tabIndex: 0,
            loading: false,
            record: {
                organisation: null,
                customer: null,
                contract: null,
                date_from: new Date(),
                undetermined: true,
                date_to: null,
                keyfob: []
            },
            errors: {},

            customerSearch: '',
            fetchingCustomers: false, // loading state
            customers: [],

            accessLevels: null,
            userDepartments: null,

            fetchingContracts: false, // loading state
            contracts: [],

            validated: false, // is the data in record{} validated?
            revoking: false,

            editingDroplet: 0,
            contractId: null, // used for the ContractsSignDocumentsModal
            contractHold: 0 // contract hold status for signing notification
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        revokable() {
            if (this.mode == 'new') return false;
            if (this.record.undetermined) return true;

            const date_to = !_.isNull(this.record.date_to) ? Math.round(new Date(this.record.date_to).getTime() / 1000) : false
            if (!date_to) return false;

            return date_to > (moment(new Date()).startOf('day')._d).getTime() / 1000
        }
    },

    created() {
        if(this.$route.params.id == 'nieuw'){
            this.mode = 'new'

            this.$set(this.record, 'organisation', this.user.organisation)

            // Set customer if we have one
            if (this.$route.query.customer){
                this.fetchCustomers(this.$route.query.customer).then((data) => {
                    this.record.customer = data[0]
                })
            }

            // Set contract if we have one
            if (this.$route.query.contract){
                this.record.contract = this.$route.query.contract
            }

            if(this.$route.query.nieuw){
                this.contractId = this.$route.query.contract
            }
        } else if (this.$route.params.id){
            this.mode = 'edit'
            this.fetchRecord()
        }

        if(_.has(this.$route.query, 'tags')){
            this.tabIndex = 1
        }
    },

    mounted() {
        if (this.$route.query && this.$route.query.nieuw) {
            this.$refs['ContractsSignDocumentsModal'].startUp() // fetch files -- if any to sign lets show the modal.

            // Fetch contract hold status if there's a contract
            if (this.contractId) {
                this.fetchContractHoldStatus()
            }
        }
    },

    methods: {
        fetchRecord(){
            console.log('[🔥] Fetch access', this.$route.params)
            this.loading = true

            axios.get('/api/access/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Set organisation
                this.record.organisation = response.data.organisation

                this.fetchCustomers(response.data.customer).then((data) => {
                    // Set customer
                    this.record.customer = data[0]
                    response.data.customer = data[0]

                    if(!_.isNull(response.data.date_to)){
                        response.data.date_to = new Date(response.data.date_to)
                        response.data.undetermined = false
                    } else {
                        response.data.undetermined = true
                    }

                    // Remove empty arrays
                    // if(response.data.keyfob.length && Object.keys(response.data.keyfob[0]) == 0){
                    //     delete response.data.keyfob
                    // }

                    this.$set(this, 'record', response.data)

                    // if(this.user.role == 'pit'){
                    //     setTimeout(() => {
                    //         this.$refs['LogsRecord'].load()
                    //     }, 250)
                    // }
                })
            }).catch((error) => {
                console.error('[❌] Error while fetching product:', error)
            }).then(() => {
                this.loading = false
            })
        },

        validateOrSave(save) {
            if (this.isSaving) return Promise.reject(new Error('Already saving'));
            this.isSaving = true;

            this.loading = true;
            this.validated = false;
            this.errors = {};

            let sendData = {...this.record};

            sendData.customer = _.has(sendData, 'customer.id') ? sendData.customer.id : null;
            if (!_.isNull(sendData.date_from)) {
                sendData.date_from = moment(sendData.date_from).format('YYYY-MM-DD');
            }
            if (!_.isNull(sendData.date_to) && !this.revoking) {
                sendData.date_to = moment(sendData.date_to).add(1, 'd').format('YYYY-MM-DD');
            } else if (!_.isNull(sendData.date_to) && this.revoking) {
                sendData.date_to = moment(new Date()).startOf('day').subtract(1, 'd').format('YYYY-MM-DD');
            }

            return new Promise((resolve, reject) => {
                axios({
                    url: `/api/access/validate${this.mode == 'edit' && save ? '/' + this.record.id : ''}${save ? '?save=true' : ''}`,
                    method: 'POST',
                    data: sendData,
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then(() => {
                    if (save) {
                        this.revoking = false;
                    }
                    resolve();
                }).catch((error) => {
                    console.error('[❌] Error while validating the access:', error);
                    this.errors = {...error.response.data.errors};
                    this.tabIndex = 0;

                    this.$buefy.toast.open({
                        message: 'Validatie mislukt - Onvoldoende of onjuiste gegevens',
                        type: 'is-danger'
                    });

                    this.revoking = false;
                    reject(error);
                }).finally(() => {
                    this.loading = false;
                    this.isSaving = false;
                });
            });
        },

        saveAndQuit(){
            this.validateOrSave(true).then(() => {
                this.showMessage(`Toegang succesvol ${this.mode == 'new' ? 'aangemaakt!' : 'aangepast!'}`)
                this.$router.push({name: 'ConnectOverview'})
            }).catch((e) => {
                console.error(e)
            })
        },

        fetchCustomersDebounce: _.debounce(function(name) {
            this.fetchCustomers(name)
        }, 200),

        fetchCustomers(name) {
            this.fetchingCustomers = true
            let params

            if(this.user.role == 'pit'){
                params = [
                `organisation=${this.record.organisation}`,
                    `${parseInt(name) ? 'customer' : 'searchterm'}=${name}`
                ].join('&')
            } else {
                params = [
                    `${parseInt(name) ? 'customer' : 'searchterm'}=${name}`
                ].join('&')
            }

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: `/api/customers?${params}`,
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.customers = response.data.data

                    return resolve(response.data.data)
                }).catch((error) => {
                    console.error('[❌] Error while fetching customers:', error)

                    return reject(error)
                }).then(() => {
                    this.fetchingCustomers = false
                })
            })
        },

        /**
         * Create or edit user on Paxton NET2.
         */
        createOrEditRecord() {
            this.validateOrSave().then(() => {
                this.validated = true

                if (this.mode == 'new') {
                    this.$refs['ConnectionModal'].promptDroplet()
                } else {
                    this.$refs['ConnectionModal'].editUser()
                }
            }).catch(() => {
                this.validated = false
            })
        },

        deselectCustomer(){
            this.record.customer = null
        },

        fetchContracts() {
            this.fetchingContracts = true

            const params = [
                `customer=${this.record.customer.id}`
            ]

            axios.get(`/api/contracts?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.fetchingContracts = false
                this.contracts = response.data.data

                if (this.mode == 'new') {
                    if(response.data.data.length == 1){
                        this.record.contract = response.data.data[0].id
                    } else if(response.data.data.length > 1 && this.$route.query.contract){
                        this.record.contract = this.$route.query.contract
                    }

                    if(response.data.data.length == 0){
                        this.record.contract = null
                    }
                }
            })
        },

        fetchContractHoldStatus() {
            if (!this.contractId) return

            axios.get(`/api/contract/${this.contractId}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.contractHold = response.data.hold || 0
            }).catch((error) => {
                console.error('Failed to fetch contract hold status:', error)
            })
        },

        setDates() {
            const selectedContract = _.find(this.contracts, ['id', this.record.contract])

            if (selectedContract) {
                this.record.date_from = new Date(selectedContract.start_date)
            }

            if(!selectedContract || selectedContract['length'] == 0 && _.isNull(selectedContract.end_date)){
                if (this.mode == 'new') {
                    this.record.undetermined = true
                }
            } else {
                if (this.mode == 'new') {
                    this.record.undetermined = false
                }

                this.record.date_to = new Date(selectedContract.end_date)
            }
        },

        passAccessLevelsAndDepartments(response){
            this.accessLevels = response.accessLevels
            this.userDepartments = response.userDepartments
        },

        revokeAccess(){
            this.record.undetermined = false
            this.record.date_to = new Date()
            this.revoking = true

            this.createOrEditRecord()
        },

        createNewKeyfob(index = false) {
            if(index) {
                // Exsisting auth -- add one
                this.$set(this.record.keyfob, index,
                    {
                        'tokenType': 'Keyfob',
                        'tokenValue': '',
                        'isLost': false
                    }
                )
            } else {
                // New auth add first
                this.$set(this.record, 'keyfob', [
                    {
                        'tokenType': 'Keyfob',
                        'tokenValue': '',
                        'isLost': false
                    }
                ])
            }
        },

        passPaxtonUser(response){
            console.log('passPaxtonUser', response)

            if(_.has(response, 'keyfob')){
                this.record.keyfob[this.record.keyfob.length - 1] = response.keyfob // always save/overwrite last one
            }

            this.record.paxton_userid = response.id
            this.saveAndQuit()
        },

        addKeyfob() {
            if(!_.has(this.record, 'keyfob')){
                this.record.keyfob = []
            }

            this.setEditingDroplet(this.record.keyfob.length)

            this.$refs['ConnectionModal'].checkConnection().then(() => {
                this.$refs['ConnectionModal'].addAuthorisation(true, this.editingDroplet)
            })
        },

        setEditingDroplet(id) {
            this.editingDroplet = id
        },

        updateDroplet(keyfob) {
            const index = _.findIndex(this.record.keyfob, (x) => { return x.id == keyfob.id})

            this.record.keyfob[index] = keyfob

            this.saveAndQuit()
        },

        deleteDroplet(keyfob) {
            _.remove(this.record.keyfob, (x) => { return x.id == keyfob.id })

            this.saveAndQuit()
        }
    },

    watch: {
        'record.organisation': function(newVal, oldVal) {
            if(newVal != oldVal){
                this.$refs['ConnectionModal'].fetchAccessLevels().then((res) => {
                    // If I have ?customer (&contract) lets set it up!
                    if(res && res == 'success' && _.has(this.$route, 'query.customer')){
                        this.loading = true

                        this.fetchCustomers(this.$route.query.customer).then((data) => {
                            // Set customer
                            this.record.customer = data[0]
                            this.loading = false
                        })
                    }
                }).catch((e) => {
                    console.error(e)
                    // this.showError('Kan geen verbinding maken met de PlanitEasy Connect server!')
                    this.$refs['ConnectionModal'].toggleModal()
                    this.$router.push({name: 'ConnectOverview'})
                })
            }
        },

        'record.customer': function(newVal) {
            if(!_.isNull(newVal)) {
                this.fetchContracts()
            } else {
                this.contracts = []
                this.customerSearch = ''
            }
        },

        'record.contract': function(newVal) {
            if(!_.isNull(newVal) && this.mode == 'new'){
                this.setDates()
            }
        },

        'record.undetermined': function(newVal) {
            if(!!newVal) this.record.date_to = null
        },

        accessLevels(newVal) {
            if(!_.isNull(newVal)){
                this.accessLevels = newVal

                if(!!this.$refs['ConnectionModal'].modalOpen){
                    this.$refs['ConnectionModal'].toggleModal()
                }
            }
        }
    }
}
</script>
